import { createTriggerResource, createMutation } from '@magicdoorinc/ui';
import { createMagicDoorContext } from '~/contexts/utils';
import { BankLedgerTransferRepository } from '~/repositories/bankLedgerTransferRepository';
import type {
  GetBankLedgerTransfersParams,
  PostBankLedgerTransferRequestDto,
  AdjustBankLedgerTransferRequestDto,
} from '~/swagger/accounting/Api';

const repo = new BankLedgerTransferRepository();

export const [BankLedgerTransfersProvider, useBankLedgerTransfers] = createMagicDoorContext('BankLedgerTransfers', () => {
  const [filtered, setFilter, actions] = createTriggerResource((filter?: GetBankLedgerTransfersParams) =>
    repo.getBankLedgerTransfers(filter || {})
  );

  const getBankLedgerTransferById = async (id: string) => {
    return repo.getBankLedgerTransferById(id);
  };

  const createBankLedgerTransfer = createMutation(async (data: PostBankLedgerTransferRequestDto) => {
    return repo.createBankLedgerTransfer(data);
  });

  const updateBankLedgerTransfer = createMutation(async ({ id, data }: { id: string; data: AdjustBankLedgerTransferRequestDto }) => {
    return repo.updateBankLedgerTransfer(id, data);
  });

  const deleteBankLedgerTransfer = createMutation(async (id: string) => {
    return repo.deleteBankLedgerTransfer(id);
  });

  return {
    filtered,
    setFilter: (filter: GetBankLedgerTransfersParams) => setFilter(filter),
    refetch: actions.refetch,
    getBankLedgerTransferById,
    createBankLedgerTransfer,
    updateBankLedgerTransfer,
    deleteBankLedgerTransfer,
  };
});
